@let t = title();
@let s = size();
@switch (t.as) {
  @case ("h1") {
    <h1 [innerHtml]="t.text | titleStyle: s"></h1>
  }
  @case ("h2") {
    <h2 [innerHtml]="t.text | titleStyle: s"></h2>
  }
  @case ("h3") {
    <h3 [innerHtml]="t.text | titleStyle: s"></h3>
  }
  @case ("h4") {
    <h4 [innerHtml]="t.text | titleStyle: s"></h4>
  }
  @case ("h5") {
    <h5 [innerHtml]="t.text | titleStyle: s"></h5>
  }
  @case ("h6") {
    <h6 [innerHtml]="t.text | titleStyle: s"></h6>
  }
  @default {
    <span [innerHtml]="t.text | titleStyle: s"></span>
  }
}
